import React, { useState } from 'react';
import { LogOut, Mountain } from 'lucide-react';
import { Toggle } from './ui/Toggle';
export function Header() {
  const [transportMode, setTransportMode] = useState<'roadways' | 'railways'>('railways');
  return <header className="w-full h-20 bg-gradient-to-r from-[#F4A460] to-[#FDBA74] px-6 flex items-center justify-between shadow-md z-50 relative" data-id="element-278">
      {/* Logo Section */}
      <div className="flex items-center gap-3" data-id="element-279">
        <div className="flex flex-col items-center justify-center" data-id="element-280">
          <div className="relative" data-id="element-281">
            <Mountain className="w-10 h-10 text-blue-700" strokeWidth={1.5} data-id="element-282" />
            <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5" data-id="element-283">
              <div className="w-2 h-2 bg-orange-500 rounded-full" data-id="element-284"></div>
            </div>
          </div>
        </div>
        <div className="flex flex-col" data-id="element-285">
          <h1 className="text-white text-xl font-bold tracking-wide drop-shadow-sm" data-id="element-286">
            TRS Himalayan Logipark Pvt. Ltd.
          </h1>
          <span className="text-white/90 text-xs font-medium" data-id="element-287">ICP Birgunj</span>
        </div>
      </div>

      {/* Right Section: Toggle, Profile, Logout */}
      <div className="flex items-center gap-6" data-id="element-288">
        {/* Toggle Switch */}
        <div className="mr-4" data-id="element-289">
          <Toggle value={transportMode} onChange={setTransportMode} data-id="element-290" />
        </div>

        {/* Profile */}
        <div className="flex items-center gap-3" data-id="element-291">
          <div className="relative" data-id="element-292">
            <div className="w-10 h-10 rounded-full bg-yellow-400 border-2 border-white flex items-center justify-center overflow-hidden" data-id="element-293">
              <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Rishi&backgroundColor=transparent" alt="Profile" className="w-full h-full object-cover" data-id="element-294" />
            </div>
            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full" data-id="element-295"></div>
          </div>
          <div className="flex flex-col text-white" data-id="element-296">
            <span className="text-xs opacity-90" data-id="element-297">Hello</span>
            <span className="font-bold text-sm leading-none" data-id="element-298">Rishi</span>
          </div>
        </div>

        {/* Logout Button */}
        <button className="bg-[#DC2626] hover:bg-[#B91C1C] text-white px-5 py-2 rounded-md flex items-center gap-2 transition-colors shadow-sm font-semibold text-sm" data-id="element-299">
          LOGOUT
          <LogOut size={16} data-id="element-300" />
        </button>
      </div>
    </header>;
}